import React from "react";
//kinesiotherapy
import Dr_Kiran_Jeswani from "../../assets/images/academics/faculty/kinesiotherapy-pt/Dr_Kiran_Jeswani.jpg";
import Dr_Priti_Patil from "../../assets/images/academics/faculty/kinesiotherapy-pt/Dr_Priti_Patil.jpg";
import Dr_Chaitali_Bhoir from "../../assets/images/academics/faculty/kinesiotherapy-pt/Dr_Chaitali_Bhoir.jpg";
import Dr_Tanushri_Supekar from "../../assets/images/academics/faculty/kinesiotherapy-pt/Dr_Tanushri_Supekar.jpg";
//Electrotherapy
import Dr_Unika_Purohit from "../../assets/images/academics/faculty/electrotherapy-pt/Dr_Unika_Purohit.jpeg";
import Dr_Kiran_Kamble from "../../assets/images/academics/faculty/electrotherapy-pt/Dr_Kiran_Kamble.jpeg";
import Dr_Omkar_Bhujbal from "../../assets/images/academics/faculty/electrotherapy-pt/Dr_Omkar_Bhujbal.jpeg";
import DROMKARBHUJBAL from "../../assets/images/academics/faculty/electrotherapy-pt/DROMKARBHUJBAL_New.jpg";
//musculoskeltal
import Dr_Sucheta_Golhar from "../../assets/images/academics/faculty/musculoskeletal-pt/Dr_Sucheta_Golhar.jpeg";
import Dr_Sanket_Nagrale from "../../assets/images/academics/faculty/musculoskeletal-pt/SanketNagrale.png";
import Dr_Siddhi_Tendulkar from "../../assets/images/academics/faculty/musculoskeletal-pt/Dr_Siddhi_Tendulkar.jpg";
import Dr_Vaishnavi_Ekbote from "../../assets/images/academics/faculty/musculoskeletal-pt/Dr_Vaishnavi_Ekbote.jpeg";
import DRMVIJAYAKUMAR from "../../assets/images/academics/faculty/musculoskeletal-pt/DRMVIJAYAKUMAR.jpg";
//neuro
import Dr_Sonal_Patole from "../../assets/images/academics/faculty/neuro-pt/Dr_Sonal_Patole.jpg";
import Dr_Shreya_Sardeshmukh from "../../assets/images/academics/faculty/neuro-pt/Dr_Shreya_Sardeshmukh.jpeg";
import Dr_Trupti_Siddhapur from "../../assets/images/academics/faculty/neuro-pt/Dr_Trupti_Siddhapur.jpeg";
import DrArulSelvan from "../../assets/images/academics/faculty/neuro-pt/DrArulSelvan.jpeg";
//cardio respiratory
import Dr_Gauri_Afle from "../../assets/images/academics/faculty/cardiorespiratory-pt/Dr_Gauri_Afle.jpeg";
import Dr_Nidhi_Ladha from "../../assets/images/academics/faculty/cardiorespiratory-pt/Dr_Nidhi_Ladha.jpg";
import Dr_Shruti_Mankar from "../../assets/images/academics/faculty/cardiorespiratory-pt/Dr_Shruti_Mankar.jpg";
//community
import Dr_Priyanka_Honkalas from "../../assets/images/academics/faculty/community-pt/Dr_Priyanka_Honkalas.jpeg";
import Dr_Harshal_Rasal from "../../assets/images/academics/faculty/community-pt/Dr_Harshal_Rasal.jpeg";
import Dr_Neha_Deshpande from "../../assets/images/academics/faculty/community-pt/Dr_Neha_Deshpande.jpg";
import { Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import DR_SONAM_JAIN from "../../assets/images/academics/faculty/community-pt/DR_SONAM_JAIN.jpg";

//dummy
import maleProPic from "../../assets/images/academics/faculty/male.png";
import femaleProPic from "../../assets/images/academics/faculty/female.png";

const musculoskeletal: ImgProps[] = [
  {
    img: Dr_Sucheta_Golhar,
    name: "Dr. Sucheta Golhar",
    designation: "Professor & Principal",
  },
  {
    img: DRMVIJAYAKUMAR,
    name: "Dr. M.Vijaya Kumar",
    designation: "Professor",
  },
  {
    img: Dr_Kiran_Jeswani,
    name: "Dr Kiran Jeswani ",
    designation: "Professor",
  },
  {
    img: Dr_Siddhi_Tendulkar,
    name: "Dr. Siddhi Tendulkar",
    designation: "Associate Professor",
  },
  {
    img: Dr_Vaishnavi_Ekbote,
    name: "Dr. Vaishavi Ekbote",
    designation: "Assistant Professor",
  },
];

const neuro: ImgProps[] = [
  {
    img: DrArulSelvan,
    name: "Dr Arul Selvan",
    designation: "HOD & Professor",
  },
  {
    img: Dr_Sonal_Patole,
    name: "Dr. Sonal Patole",
    designation: "Associate Professor",
  },

  // {
  //   img: Dr_Trupti_Siddhapur,
  //   name: "Dr. Trupti Siddhapur",
  //   designation: "Associate Professor",
  // },
  {
    img: Dr_Shreya_Sardeshmukh,
    name: "Dr. Shreya Sardeshmukh",
    designation: "Assistant Professor",
  },
];
const cardiovascular: ImgProps[] = [
  {
    img: Dr_Gauri_Afle,
    name: "Dr. Gauri Afle",
    designation: "Professor",
  },
  {
    img: Dr_Nidhi_Ladha,
    name: "Dr. Nidhi Ladha",
    designation: "Associate Professor",
  },
  {
    img: Dr_Shruti_Mankar,
    name: "Dr. Shruti Mankar",
    designation: "Assistant Professor",
  },
];

const community: ImgProps[] = [
  {
    img: Dr_Priyanka_Honkalas,
    name: "Dr. Priyanka Honkalas",
    designation: "Professor",
  },
  {
    img: Dr_Neha_Deshpande,
    name: "Dr. Neha Deshpande",
    designation: "Associate Professor",
  },
  {
    img: DR_SONAM_JAIN,
    name: "Dr Sonam Jain",
    designation: "Associate  Professor",
  },
  {
    img: Dr_Harshal_Rasal,
    name: "Dr. Harshal Rasal",
    designation: "Assistant Professor",
  },

];

const kinesiotherapy: ImgProps[] = [
  {
    img: Dr_Priti_Patil,
    name: "Dr. Priti Patil",
    designation: "Associate Professor",
  },
  {
    img: Dr_Chaitali_Bhoir,
    name: "Dr. Chaitali Bhoir",
    designation: "Assistant Professor",
  },
  {
    img: Dr_Tanushri_Supekar,
    name: "Dr. Tanushri Supekar",
    designation: "Assistant Professor",
  },
];

const electrotherapy: ImgProps[] = [
  // {
  //   img: Dr_Unika_Purohit,
  //   name: "Dr. Unika Purohit",
  //   designation: "Associate Professor",
  // },
  {
    img: Dr_Kiran_Kamble,
    name: "Dr. Kiran Kamble",
    designation: "Assistant Professor",
  },
  {
    img: DROMKARBHUJBAL,
    name: "Dr. Omkar Bhujbal",
    designation: "Assistant Professor",
  },
];

export const allData = new Map([
  ["Department of Musculoskeletal Physiotherapy", musculoskeletal],
  ["Department of Neuro Physiotherapy", neuro],
  ["Department of Cardiovascular & Respiratory", cardiovascular],
  ["Department of Community Physiotherapy", community],
  ["Department of Kinesiotherapy & Physical Diagnosis", kinesiotherapy],
  ["Department of Electrotherapy", electrotherapy],
]);

const Faculty = () => {
  return (
    <Stack
      sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
      spacing={4}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      {Array.from(allData.entries()).map(
        ([departmentName, facultyMembers], i) => {
          return (
            <React.Fragment key={departmentName + i}>
              {i > 0 && (
                <Divider
                  sx={{
                    my: 2,
                    width: "100%",
                    borderTop: "5px dotted #002147",
                  }}
                />
              )}

              <Typography
                id={departmentName}
                variant="h4"
                sx={{
                  textAlign: "left",
                  alignSelf: "baseline",
                  textDecoration: "underline",
                  textUnderlineOffset: "6px",
                }}
              >
                {departmentName}
              </Typography>

              <Grid container columns={{ xs: 1, sm: 2, md: 4 }} spacing={2}>
                {facultyMembers?.length > 0 ? (
                  facultyMembers.map((current, i) => (
                    <Grid item xs={1} key={i}>
                      <Img {...current} />
                    </Grid>
                  ))
                ) : (
                  <Typography
                    variant="h6"
                    sx={{ width: "100%", textAlign: "center" }}
                  >
                    ... will update soon
                  </Typography>
                )}
              </Grid>
            </React.Fragment>
          );
        }
      )}
    </Stack>
  );
};

interface ImgProps {
  img: string;
  name: string;
  designation: string;
}

const Img = ({ img, name, designation }: ImgProps) => {
  return (
    <Paper
      sx={{
        maxHeight: { xs: 300 },
        minHeight: { xs: 300 },
        overflow: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        p={1}
      >
        <img
          src={img}
          width="200px"
          height="200px"
          alt="Faculties"
          style={{ objectFit: "contain" }}
        />
        <Typography color="primary.main" mt={2}>
          <span style={{ fontWeight: "bold" }}>Name:&nbsp;</span>
          {name}
        </Typography>
        <Typography color="primary.main" noWrap>
          <span style={{ fontWeight: "bold" }}>Designation:&nbsp;</span>
          {designation}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default Faculty;
